import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CandidateService } from '../services/candidate.service';
import { VendorService } from '../services/vendor.service';
import { AdminService } from '../services/admin.service';
import { FooterMoreInfoComponent } from '../home/landing-root/footer-more-info/footer-more-info.component';
import { OurAppsComponent } from '../home/about-root/our-apps/our-apps.component';
import { HeaderLatestComponent } from '../home/landing-root/header-latest/header-latest.component';


@Component({
  selector: 'app-verify-business-partner-email',
  standalone: true,
  imports: [FooterMoreInfoComponent, OurAppsComponent, HeaderLatestComponent],
  templateUrl: './verify-business-partner-email.component.html',
  styleUrl: './verify-business-partner-email.component.scss'
})
export class VerifyBusinessPartnerEmailComponent {
value!: string;


  statusMessage:''
  successMessage:boolean=false
  constructor
  ( 
    private router:Router, 
    private route: ActivatedRoute,
    private candidateService:CandidateService,
    private adminService:AdminService,

  ) 
  { }


  ngOnInit(): void {
    console.log("ngOnInit works");
    const verifyKey = this.route.snapshot.queryParams['verify_key'];
    console.log("Verify Key:", verifyKey);
    if (verifyKey) {
      this.emailBusinessPartnerVerification(verifyKey);
    }
  }
  
    
  emailBusinessPartnerVerification(verifyKey:any) {

    let reqObj = {
      verify_key:verifyKey
    }
    this.successMessage =false
    this.adminService.emailBusinessPartnerVerification(reqObj).subscribe((resp:any)=>{
      console.log("Rec profile update success", resp);
      this.statusMessage=resp.supportMessage

      if(resp.statusCode ==200){
        this.successMessage = true
        console.log("HHHHHHH",this.successMessage)
        // this.errorStatus =true;
        // this.errorMsg = resp.supportMessage;
        // this.snackBarSimpleComponent.openSnackBar(resp.supportMessage,"","center","top",3);
        
        // this.router.navigate(['matrimonials/thankyou']);
      }
    });
  }

  
}
